import React from "react";

import Modal from "../../General/Modal/Modal";

type OwnProps = {
  close: () => void;
  logOut: () => void;
};

type Props = OwnProps;

const LogOutConfirm: React.FC<Props> = ({ close, logOut }) => {
  return (
    <Modal>
      <div className="confirm_popup">
        <h3 className="confirm_popup__heading">提示</h3>
        <p className="confirm_popup__text">確定要登出？</p>
        <div className="confirm_popup__btn">
          <button
            onClick={close}
            className="confirm_popup__btn--btn btn__switch"
          >
            取消
          </button>
          <button
            onClick={logOut}
            className="confirm_popup__btn--btn btn__primary"
          >
            確認
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LogOutConfirm;
